import { Table } from "react-bootstrap";
import { formatTerritory } from "../../mocks/va/mockData";
import Pagination from "../shared/pagination/Pagination";
import Loader from "../shared/loader/Loader";

function formatCurrency(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);
}

export default function VaDistributorTable({
  items,
  isLoading,
  page,
  pageSize = 20,
  totalPages,
  total,
  onPageChange,
  onEdit,
  onCommissionHistory,
}) {
  if (isLoading) {
    return (
      <div className="va-distributors-table-wrap">
        <Loader />
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="text-center py-5">
        <p className="text-muted mb-0">No distributors yet</p>
      </div>
    );
  }

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="va-distributors-table-wrap">
      <div className="table-scroll">
        <Table className="mb-0 va-distributors-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Location</th>
              <th>Assigned Orders</th>
              <th>Cancelled Orders</th>
              <th>Commission Paid</th>
              <th>Commission Pending</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr
                key={row.id}
                className={onEdit ? "va-distributors-table__row--clickable" : undefined}
                onClick={() => onEdit?.(row)}
              >
                <td>{row.name}</td>
                <td>{row.email}</td>
                <td>
                  {(row.territories || []).map(formatTerritory).join(", ") ||
                    (row.hospitalIds?.length
                      ? `${row.hospitalIds.length} hospital${
                          row.hospitalIds.length === 1 ? "" : "s"
                        }`
                      : "—")}
                </td>
                <td>{row.assignedOrderCount ?? row.ordersCount ?? 0}</td>
                <td>{row.cancelledOrderCount ?? 0}</td>
                <td>
                  <button
                    type="button"
                    className="va-distributors-amount va-distributors-amount--paid va-distributors-amount--history"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCommissionHistory?.(row);
                    }}
                    title="View commission history"
                  >
                    {formatCurrency(row.paidCommission)}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    className="va-distributors-amount va-distributors-amount--pending va-distributors-amount--history"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCommissionHistory?.(row);
                    }}
                    title="View commission history"
                  >
                    {formatCurrency(row.pendingCommission)}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="va-distributors-table__footer">
        <span className="text-muted small">
          Showing <strong>{start}-{end}</strong> of <strong>{total}</strong>
        </span>
        {totalPages > 1 && (
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}
